import { Button, Form, FormProps, Input, Radio, Space } from "antd";
import { ModalComponentProps } from "../../types";
import CustomModal from "../ui/CustomModal";

export default function AddCategoryModal({
  handleClose,
  type,
  data,
  ...rest
}: ModalComponentProps) {
  const onFinish: FormProps<any>["onFinish"] = (values) => {};
  const [form] = Form.useForm();

  return (
    <CustomModal
      title="Add Category"
      {...rest}
      handleClose={handleClose}
      width={600}
      footer={null}
    >
      <Form
        name="form_item_path"
        className="custom-form bg-white rounded-md"
        layout="vertical"
        onFinish={onFinish}
        requiredMark="optional"
        size="large"
        form={form}
      >
        <Form.Item
          name=""
          label="Product Category Title"
          className="mb-4"
          rules={[
            {
              required: true,
              message: "Please enter Product Category Title",
            },
          ]}
        >
          <Input size="large" placeholder="Category Title" />
        </Form.Item>

        <Form.Item
          name="status"
          rules={[
            { required: true, message: "Please select the system status" },
          ]}
        >
          <div className="flex gap-4">
            <div>System Status</div>
            <Radio.Group>
              <Radio value="active">Active</Radio>
              <Radio value="inactive">Inactive</Radio>
            </Radio.Group>
          </div>
        </Form.Item>

        <Space className="w-full mt-2" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
          >
            Request to Active
          </Button>
        </Space>
      </Form>
    </CustomModal>
  );
}
